<template>
    <div>
        <vs-popup title="" 
            :button-close-hidden="true" 
            :active.sync="isActive" 
            @close="$emit('isActiveFalse')"
            style="border-radius: 10px !important;"
            id="popUpDelivery"
        >
            <div>
                <span id="display-span-orders">
                    <vs-icon @click="isCreateContext ? $emit('backToQuantity') : $emit('backToOrderSummary', 'delivery')" class="mr-2" icon="keyboard_arrow_left" style="border: solid 1px; border-radius: 14px; cursor: pointer;"/>
                    <p class="ml-2" style="font-size: 16px; width: 400px;">Entrega (opcional)</p>
                    <div class="flex-end-align">
                        <vs-icon @click="closePopUp" class="mr-2" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right;"></vs-icon>
                    </div>
                </span>
            </div>

            <div>
                <ul class="leftx">
                    <li>
                        <div>
                            <vs-icon icon="motorcycle" size="80px"/>
                        </div>
                        <div @click.prevent="handleRadioClick('delivery')" @touchstart.prevent="handleRadioClick('delivery')">
                            <vs-radio 
                                v-model="delivery" 
                                vs-name="delivery" 
                                vs-value="delivery"
                            >
                                Entrega
                            </vs-radio>
                        </div>
                    </li>
                    
                    <li>
                        <div>
                            <vs-icon icon="store" size="80px"/>
                        </div>
                        <div @click.prevent="handleRadioClick('not_delivery')" @touchstart.prevent="handleRadioClick('not_delivery')">
                            <vs-radio v-model="delivery" vs-name="delivery" vs-value="not_delivery">Retirada</vs-radio>
                        </div>
                    </li>
                </ul>
            </div> 

            <div v-if="delivery === 'delivery'" id="align-delivery-content">
                <div class="mb-4">
                    <span> CEP </span>
                    <vs-input v-mask="'#####-###'" class="smallSizeOfInputDelivery mt-2" placeholder="Digite o CEP" type="text" v-model="cep" @input="screenCep"/>
                </div>
                <div class="mb-4">
                    <div>
                        <span> Logradouro (Rua) </span>
                        <vs-input class="bigSizeOfInputDelivery-street mt-2" placeholder="Digite o endereço" type="text" v-model="address"/>
                    </div>
                    <div class="ml-4">
                        <span> Bairro </span>
                        <vs-input class="bigSizeOfInputDelivery-street mt-2" placeholder="Digite o bairro" type="text" v-model="district"/>
                    </div>
                    <div class="ml-4">
                        <span>Cidade</span>
                        <vs-input 
                            class="smallSizeOfInputDelivery mt-2" 
                            placeholder="Digite a Cidade" 
                            type="text" 
                            v-model="city"
                        />
                    </div>
                    <div class="ml-4">
                        <span> UF </span>
                        <vs-input 
                            class="smallSizeOfInputDelivery mt-2 mr-4" 
                            placeholder="Digite o Estado" 
                            type="text" 
                            v-model="state"
                            maxlength="2"
                        />
                    </div>
                </div>
                <div class="mb-4">
                    <div>
                        <span> Complemento </span>
                        <vs-input 
                         class="bigSizeOfInputDelivery mt-2" 
                         placeholder="Digite o complemento" 
                         v-model="complement"
                         maxlength="20"
                        />
                    </div>
                    <div class="ml-4">
                        <span> Número </span>
                        <vs-input 
                            class="smallSizeOfInputDelivery mt-2" 
                            placeholder="Digite o número" 
                            type="number" 
                            v-model="number"
                        />
                    </div>
                    <div class="ml-4">
                        <p> Valor de Entrega </p>
                        <div :class="{ 'highlight mt-2': isInputFocused, 'money-div mt-2': !isInputFocused }">
                            <span class="p-2 pr-0" style="font-size: 13.8px;">R$</span>
                            <vs-input 
                             @focus="highlightInput" 
                             @blur="highlightInput" 
                             v-mask=" ['#.##','##.##','###.##','####.##','#####.##','######.##',]"
                              v-model="delivery_fee" 
                             id="delivery-fee-input"
                            />          
                        </div> 
                    </div>
                </div>
            </div>

            <div>
                <vs-button @click="checkIfDataIsEmpty" class="btn-drop px-3 mr-5 mt-2" type="filled" icon="keyboard_arrow_right" icon-after style="float: right !important; border-radius: 12px;">
                    <span>{{ isCreateContext ? 'Próximo/Pular' : 'Atualizar/Pular' }}</span>
                </vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    import moduleOrder from '@/store/order/moduleOrder';
    import clientCep from '@/http/requests/tenantInfo/cep.js'

    export default {
        name: 'DeliveryPopUp',
        data() {
            return {
                delivery: 'none', 
                cep: '',
                address: '', 
                number: undefined,
                state: '',
                city: '',
                district: '',
                complement: '',
                isInputFocused: false,
                delivery_fee: 0.0,
                selectedRadio: null,
            }
        },
        mounted() {
            this.$events.off('cleanDelivery')
            this.$events.on('cleanDelivery', ({ file }) => {
                if  ( file === 'Delivery' ) {
                    this.cep          = '',
                    this.number       = undefined;
                    this.address      = '';
                    this.delivery     = 'none';
                    this.complement   = '';
                    this.delivery_fee = 0.0
                    this.selectedRadio = null;
                }
            })
        },
        methods: {
            handleRadioClick(value) {
                this.delivery = value

                if (this.selectedRadio === value) {
                    this.delivery = 'none'
                    this.selectedRadio = null;
                    return;
                }

                this.selectedRadio = value;
            },
            screenCep(e) {
                this.searchCep(e)
            },
            searchCep(cep, number) {
                let loadedCep = clientCep.showCep(cep)

                if (loadedCep) {
                    loadedCep.then(response => {
                        return response.json()
                    }).then(response => {
                        this.state      = response.uf;
                        this.city       = response.localidade;
                        this.district   = response.bairro;
                        this.address    = response.logradouro
                        this.complement = response.complemento

                        if (!this.complement) {
                            this.complement = this.customerAddress.complement
                        }

                        if (this.cep === ''){
                            this.cep = response.cep
                        }
                        this.number = number
                    })
                }
            },
            closePopUp() {
                this.isActive = false;
                this.$emit('isActiveFalse');
            },
            checkIfDataIsEmpty() {
                if (this.delivery == "delivery") {
                    if (
                        !this.cep     ||
                        !this.address ||
                        !this.number  ||
                        !this.city    ||
                        !this.state   ||
                        !this.district
                    ) {
                        return this.$vs.notify({
                            color: 'danger',
                            title: 'Existem campos que não foram preenchidos!',
                            text: 'Preencha os campos para prosseguir'
                        });
                    }

                    if (!this.isCreateContext) {
                        this.dataToUpdate.is_delivery = this.delivery == 'delivery';

                        var data = {
                            type: this.dataToUpdate.is_delivery,
                            cep: this.cep,
                            address: this.fullAddress,
                            number: this.number,
                            delivery_fee: this.delivery_fee || 0.0,
                            complement: this.complement
                        };
                        this.dataToUpdate.address = JSON.stringify(data);
                        const parsedAddress = JSON.stringify(data);

                        this.updateDelivery(this.dataToUpdate, parsedAddress);
                        this.$emit('updateOrderDelivery', this.dataToUpdate);
                        return ;
                    }

                    if (this.dataOfProductsToPreOrder.delivery !== undefined) {
                        delete(this.dataOfProductsToPreOrder['delivery']);
                    }

                    var data = this.dataOfProductsToPreOrder;
                    data.delivery = {
                        typeOfDelivery: this.delivery,
                        cep: this.cep,
                        address: this.fullAddress,
                        number: this.number,
                        delivery_fee: this.delivery_fee || 0.0,
                        complement: this.complement
                    }
                } else {
                    if (!this.isCreateContext) {
                        this.dataToUpdate.address = null;
                        this.dataToUpdate.is_delivery = this.delivery == 'delivery';

                        this.updateDelivery(this.dataToUpdate);
                        this.$emit('updateOrderDelivery', this.dataToUpdate);
                        return;
                    }

                    if (this.dataOfProductsToPreOrder.delivery !== undefined) {
                        delete(this.dataOfProductsToPreOrder['delivery']);
                    }

                    var data = this.dataOfProductsToPreOrder;
                    data.delivery = {
                        typeOfDelivery: this.delivery,
                        cep: this.cep,
                        address: this.fullAddress,
                        number: this.number,
                        delivery_fee: this.delivery_fee || 0.0,
                        complement: this.complement
                    }
                }

                this.chatContact.customer.address = JSON.stringify(data.delivery);

                this.$emit('sendToPayment', data)
            },
            async updateDelivery(data, parsedAddress = null) {
                if (!moduleOrder.isRegistered) {
                    this.$store.registerModule('order', moduleOrder)
                    moduleOrder.isRegistered = true
                }
                await this.$store.dispatch("order/updatePreOrders", {
                    id: data.id,
                    address: parsedAddress,
                    is_delivery: data.is_delivery,
                    payment_data: data.payment_data
                })
                .then((response) => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Sucesso!',
                        text: 'Atualização feita com sucesso!'
                    })
                })
                .catch((exception) => {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Erro!',
                        text: 'Erro ao atualizar os dados, por favor nos contate para corrigir-mos!'
                    });
                    console.log(exception);
                });
            },
            highlightInput() {
                this.isInputFocused = !this.isInputFocused;
            },
            setAddress() {
                if (this.customerAddress.address !== 'none') {
                    this.searchCep(this.customerAddress.cep, this.customerAddress.number);
                }
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            dataOfProductsToPreOrder: {
                type: Array|Object,
                required: true
            },
            dataToUpdate: {
                type: Array|Object,
                required: true
            },
            chatContact: {
                required: true,
                validator: prop => typeof prop === 'object' || prop === null
            },
            isCreateContext: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            fullAddress() {
                return this.address + ', ' + this.district + ', ' + this.city + ', ' + this.state;
            },
            customerAddress() {
                return typeof JSON.parse(this.chatContact.customer.address) === 'string' ? JSON.parse(JSON.parse(this.chatContact.customer.address)) : JSON.parse(this.chatContact.customer.address);
            }
        },
        emits: [
            'isActiveFalse',
            'backToQuantity',
            'backToOrderSummary',
            'updateOrderDelivery',
            'sendToPayment'
        ],
        watch: {
            'delivery_fee'(value) {
                if (value < 0) {
                  this.delivery_fee = value * -1;
                }
            },
            'isCreateContext'() {
                if (!this.isCreateContext) {
                    const parsed = JSON.parse(this.dataToUpdate.address);
                    this.delivery = this.dataToUpdate.is_delivery ? 'delivery' : 'not_delivery';

                    if (this.dataToUpdate.is_delivery) {
                        this.cep = parsed.cep;
                        this.address = parsed.address; 
                        this.number = parsed.number;
                        this.complement = parsed.complement;
                        this.delivery_fee = parsed.delivery_fee;
                    }
                }
            },
            'delivery':{
                handler(newVal) {
                    if (this.isCreateContext && this.chatContact.customer.address) {
                        this.setAddress();
                    } else {
                        this.cep = '';
                        this.number = undefined;
                        this.address = '';
                        this.complement = '';
                    }

                    if (newVal === 'none') {
                        this.selectedRadio = null;
                    }
                },
                deep: true
            },
            'isActive'() {
                if (this.isCreateContext && this.chatContact.customer.address && this.cep === '') {
                    this.setAddress();
                }
            }
        },
    }
</script>

<style lang="scss">
    #popUpDelivery div.vs-popup {
        .vs-popup--content {
            padding: 15px;
            margin: 0;
        }
        margin: 0;
        border-radius: 18px !important;
        border: solid 1.2px;
        border-color: rgba(18, 17, 17, 0.769);
        width: 700px !important;
        .vs-popup--header {
            background-color: transparent !important;
            .vs-popup--title {
                background-color: transparent !important;
                h3 {
                    background-color: transparent !important;
                }
            }
        }
        header {
            background-color: transparent !important;
        }
        li div:first-of-type {
            height: 70px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 20px;
        }
        ul.leftx {
            display: flex;
            justify-content: space-evenly;
            flex-direction: row;
            align-items: center;
            text-align: center;
            margin-top: 10px;
        }
        #align-delivery-content {
            margin-left: 18px;
            > div:nth-of-type(2) {
                display: flex;
            }
            > div:last-of-type {
                display: flex;
            }
        }
        input.vs-inputx.vs-input--input.normal {
            border-radius: 14px !important;
        }
        .smallSizeOfInputDelivery.mt-2 {
            width: 120px !important;
        }
        .bigSizeOfInputDelivery.mt-2 {
            width: 355px !important;
        }
        .bigSizeOfInputDelivery-street {
            width: 170px !important;
        }
        .money-div{
            display: flex; 
            width:120px !important;
            align-items: center; 
            border: 1px solid #b6bebdd2; 
            border-radius: 14px; 
            transition:.3s;
        }
        .highlight{
            display: flex; 
            width:120px !important;
            align-items: center; 
            border: 1px solid #409eff !important; 
            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
            border-radius: 14px; 
            transition:.3s;
        }
    }
    #delivery-fee-input {
        width: 115px;
        box-shadow: none !important;
        border:none !important;
        background-color: transparent;        
        font-size: 15px;
        background-color: transparent; 
    }
</style>